module.exports = __webpack_public_path__ + "img/logo_com_gorro.817c3678.png";